<template>
  <!-- 右侧功能栏 -->
  <div class="rightgongju" style="margin-top: 67px">
    <!---->
    <ul>
      <li class="hover-actived xcx">
        <img
          class="a"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAABLBJREFUaEPlmd1R3DAQgKWx/BxSQUgFoYNwM0ivgQoCFYRUEKgAqCCkAuBVZuaOCkIqSFJB4Nn2bW5vZI9ly9LK9hGSaCZzTGz9fLvr/RNn/9jg/xgPmxRoPp9vFUXxljG2wxjbNcKqfivZLcwf+HsvhLibzWYPUwl2NBBClGX5brlcHnPOEWTIuF7NvU6S5GYs3GAgo40PjLFjxtjWEArHHNTUuRDiYijYICCt9QfO+cmEIG22BwA4UUpdxAoqCmg+n2/neX41wrRiz7cQQhzNZrMf1IlkoNvb230A+LxBrfSdGc3wQEpZORMvGwlIa33IOUeYPzYA4EgpdRk6QBDoOcBUEBQoL5Axs6uQVJ74+cxnfr1A6ACKovj6B76ZkHwehBCv+9x6L5DW+usTerMQRPv5Qko5c01yAmVZhjHmU+wuMe8DwLdVUF6nPEZwLyLnO51EB2jDpvZoMoHztslorTFtwvTpPRHMaXodIK31OeccU5pJB2okTdPdUEpjwC45528IBziVUqI11cMCMvnZ96kdARWmOpU5xz1j7FUAqqMlCyjLMkw0zwiSiXrFeCUrfUHTLssSSw2WJAmWENZzavxrxyYLaBOeDQC+KKUOW9LHrGO/KRUAuFRKHTX/byVgdBohZ3EjpazXqoGMmn9FiZ728kcp5Xn1qs+DtqWttV5wztda9A0pZc1R/0FVcWhxx3MrsgeswJI2FYgxVu/RBNqId2tuhrBZlkGfUNrmGQFUe7smEEm9YzXkAXoEgF2lFHq39dBaf+ecbxP2rDXbBKJOJqxvvWKZnAvIZA2HTZgsy7C5MqdsBgB3Sql1M6YG8plCYNGfWC6naXqN8SvPc2x4NINiCMhyGg3ngTDtjpHzKFMCnQohrDTGUXL0AgHAhVIKY581hsTDytMN1hDn/GBvbw+1Yg2Ht/RpqKOdlaVgUmylMxSzGwvUOYinreUDwsB5CAD4i8kplvrRvb0+k8PUI5Q7obAeV4HS6sOhmS2Xy7MejxT6higK8L7jBIrw+VbwI5QbTwFUp1fNb4ha1FlAhA9440Arb90NrNSGSFO9Jvh5W1zNPCuUKYywvW7qE5GcPkgpX1abm3n4/bmy4rY2ycEyBs6ZnBpp31MqxbbLNlEdXXgNhZpM03S/WaFqrbESpZbYVCZ3+UAxn8YOna6L0dTa5QohfjgKth3OObbFJh3eAi9gPu2DdOr5vpPiunmez4fEmAB9J4R0miSRLayTlf2e+jY1TQ+8saBkzbHa8zdJcDUTVzCFD5W+680BAL87BLtpnsaA4D1SXX7HnjakHSHEdruLNGmj0cBhGkPKkscA9jXufa1gkscbc6ihc9uxsLlOqFlPNr2hhxsw79FlatU6f9t1SqdMbwvk/7rwqug32OKiWhxq5niSK8lqR5O84h0nyZ1TT0p4L2hmJKfg2shc67ebIIQzDXvFlQ+GVgp+Q64FTA2E9dOmtEU2sWin4MvPiqLAjg3+mwqs90IspBmS26YsYhJP7P5joRdsrPeseQMA19jbC12Ihc40yOR8WivLcnd1OCwjdgBgq3V/iqaEGQimR/h7nyTJYizEYKcQks5zeD6php4D0G9eWc9T2E+yHQAAAABJRU5ErkJggg=="
          data-extentions-extra-ocr-id="58d4d34a66464ea5ae1862ae483f67ac"
        />
        <span>小程序</span>
        <div class="chengxu_em" style="display: none">
          <img
            src="@/assets/images/codes.png"
            data-extentions-extra-ocr-id="d5c4f59ae7e45907eb3cf094e565c84f"
          />
          <span class="qrcode-text" style="margin: 0">扫码访问小程序</span>
        </div>
      </li>
      <li class="hover-actived kf">
        <img
          class="a"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAABZJJREFUaEPVWttx2zgUJWzyO0kF61SwdgUxZwz8xq7AdgXrVBC7gjgVRKlglV9AM1IqiLeCyBWs/S1ad3kwIAeEABIkpWiDn8gRXue+74FYsoMhpTxOkuQVY+x1kiT4jPFARE/4IIT4voNj9ZZsWxsrpd4nSXJKROeMsaOOfZ+IaHpwcLA4PDz8lue5BrqNMRrQbDa7XK/XtxEgQvcFmPs0TT9vA9hgQLPZ7Hy9Xn8aAcQFqIFxzu/GaGoQIKXUpyRJbnwHE9E/jLFpaX4LfJ+m6QP+LYqi8qVjY5bvAhefpml6PVRbvQDN5/PXRVH8DV9xLvNszGaS5/kyRsLYa7Vawd/uEUDsNUSEPS6EEFoYfUY0IHOBeSn9StL6HCL6mmXZbSwQ93JGSND2R+c7BI68L6hoQEopaObcOvS5DMM3QohJHwmG5iLUM8ZgprW2StN8yLIs72N+UYCklPeMsb8cMKch6VV5CDnI5KKEMbZcr9fLLMseQ9o0VrBgjP1ZnQVQQoiTWKF1AlJKwV/mjo2fuGAwj4guGWPQIhJqcBgfWWRZdueCMyYIH7L96gPnHL7WOToBSSl/2H5DRNe2mRlTQdRzA0Xn4cYHJy4wj/k9pWn6Nsb0WgFJKa8YY18s9X8VQlxVfyMXERG+b9VIBDLkoAvOuQ71GEqpWztQIPjYZ4f27ALU0I6Rkg7LBgwCxTZHXoEypoew/Yc5IEpLQUDz+fyoKIqfPu0Yk4BfjdWMKwxc+qTyK4+FNMzdJ8kgIDeyEVEdCJRSADPIZyLU+Y1zrtOD0dK/1poF5zxv26MNkG1uj5xzXUEb7fyIuNjgKbZpK6VQRqGS16Os9VrdJPilUoosc/sshNC1m5Rywhi7HHzbiIV2APCY3UbKsLf0AnL9p+yb7jjniDoA9HOLFbYXHvKUEOKtiXaNPMgYuzg7O4PWvMMLyJNMdfTxAI2Q97Apldl5gtNECHEdDciULV+cIlQD8lUNw64btaoO4bb5m5W64/VVGhsaUkohqjTCcdlNvkGW3iMg5L4qH9XSsE2z+k8foDoYJEnSqKjd7B0l5+GTbL9Fy4ICeaMpdKNeF6B6U+OgjXJk+F2jVjbOxgrjTyhSg2H8twLkE+pvraFdANrojaKMZ9ikhskh+qIHc/14rIZ+FaA6GNmFMBGhSnm024p9AXokIrTWy/JSqAldZnWJ70pqDH3Rg9VCoOJH3WinEfB2NaHSF1Cj9fVUv53GZFihm5hus9rMaAWRDPWjDQZ0GSItOmQ9OgFJKR8MSfGcpumx2/MrpSDFBo/WgkpX6Yb8AN+gL2dIe825lUyP3YbgM3JOqM/K0zRdFkWBta9AagohGrTaRtg2WjjGQh87I6WE6YRYTxeb1rDbAnSq1TPB5jJMPjoCK+tqvpMkcffuUy1Ul/DUYtGYSrLxe5ZlV7FEZm9AfRo8ItJ9lIfXawUEEODHS5OfxgIJ1nIxolNKeYtFz9qa2DCCqB7AGj5Scnn6MSxk5jF3GgsI0aeONG0HDqFz+wBw5/Y2OVMk4hXCZTe77gHOrebdApMR5VAhdM0LnjUIEHbbBS8H3xFCjGKTBgMCqG2E40rUyClZlp32ScA+NY0CZBImGq9RLNC2wOhE3WX4Md+P1NSjqUi28hI+GJCU8p0pW/Bminegrqf8kGwABEEAoXsx9jcM0YBgXi8vL+/x4Ou85MUose+cKRLrkN8wdAJC3bRarT7GPGT1vXXE/N6/YWgFVNZg6Ds0Y7rnAR7uQ8x7bogKxpP7xov3nkGh7WhlTb1RLvR8v28wVr6qHw6i8lCf9mBfIO3nls5azkcF7+viLedukJDV3C6i8X+IRbfwwZrPByi219kb2LY3og1A5jkF/c7QzL8zoIyxp7IimfR+8NrZjX7Bxv8BBBhMYlNzkfIAAAAASUVORK5CYII="
          data-extentions-extra-ocr-id="119269c7a2a3747e0ec4e39ed4c2e40d"
        />
        <span>联系客服</span>
        <div class="kf_tel" style="display: none">
          <div class="toptel">
            <div class="leftphoto">
              <img
                src="@/assets/images/kf.png"
                alt=""
                data-extentions-extra-ocr-id="c896911f2ecf0f17a7461cd3ca184e1f"
              />
            </div>
            <div class="rightphone">
              <div style="margin-bottom: 4px">客服电话</div>
              <div>400-621-1003</div>
            </div>
          </div>
          <div class="bottomma">
            <img
              data-extentions-extra-ocr-id="e3b0c44298fc1c149afbf4c8996fb924"
              src="@/assets/images/ewm.jpg"
            />
            <div>微信扫码添加客服微信</div>
          </div>
        </div>
      </li>
      <li class="hover-actived" style="background: rgb(255, 255, 255)" @click="go()">
        <img
          class="a"
          src="data:image/png;base64,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"
          alt=""
          data-extentions-extra-ocr-id="c3540656dd4a3f7d21c1d63ad010d79c"
        />
        <span style="color: rgb(97, 55, 0)">开通VIP</span>
      </li>
      <li
        @click="backToTop()"
        class="hover-actived"
        style="height: 28px; background: rgb(255, 255, 255)"
      >
        <img
          class="a"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAWNJREFUOE/t071KA0EQB/D/3L2DrY9g4yvYWN/uhKtFgjZ+BJUYRIIY0SgSLESs9W730gqCT2DtA9jnCVLcjqxoSPSS05DCwi13d36zOztLmPGgGXv4B4sr2u12436/L3Ec35fVvLSG1tqGc26XiCAiLWY+noROBNM0rQPwWA/wnswRUUtrfTIOHQsaY/YAeNBjVQChiFwRkUePlFKnRWghaK3dEZF9EemFYbgeRdGjD86ybDnP845HRaTJzO2v6DcwTdMaER0ACEREM/PDcJC1dkVELgE4AIda64vh9RHQGLPlNwEgItpUSt0WXcsYswrg3NfVJ1dK+QTvYwAmSbIRBEHzY25ba30z6TWzLKvmed4mIiciDWbuDMAkSRaI6I6I5oMgqEVRdF3Wb37dWrvmnDsD8CoiXKlUXgYntNbWnXPPzPz0E+xzjzFmiYgWlVKtkSv/Bpm6sadJUvr1fov+ffANfsuIFW4HDQcAAAAASUVORK5CYII="
          data-extentions-extra-ocr-id="5178289b0e1a353c3d9007afd9994ece"
          style="top: 0px"
        />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "BackToTop",
  props: {
    // 距离顶部多远出现按钮
    visibilityHeight: {
      type: Number,
      default: 100,
    },
    // 返回顶部后离顶部的距离
    backPosition: {
      type: Number,
      default: 0,
    },
    customStyle: {
      type: Object,
      default: function () {
        return {
          right: "40px",
          bottom: "40px",
          width: "40px",
          height: "40px",
          "border-radius": "20px",
          "line-height": "50px",
          "background-color": "#00000073",
        };
      },
    },
    transitionName: {
      type: String,
      default: "fade",
    },
  },
  data() {
    return {
      visible: false,
      interval: null,
      isMoving: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    go(){
      this.$router.push('/Home/ClubCard')
    },
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight;
    },
    backToTop() {
      if (this.isMoving) return;
      const start = window.pageYOffset;
      let i = 0;
      this.isMoving = true;
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
          this.isMoving = false;
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 16.7);
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
  },
};
</script>
<style lang="less" scoped>
.xcx:hover .chengxu_em {
  display: block !important;
}
.kf:hover .kf_tel {
  display: block !important;
}
.rightgongju {
  width: 76px;
  position: fixed;
  right: 12px;
  bottom: 3%;
  z-index: 700;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 3px 22px 1px rgba(0, 0, 0, 0.06);
  ul {
    list-style: none;
    padding: 3px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    li:first-child {
      margin-top: 0;
    }
    li {
      width: 70px;
      height: 76px;
      position: relative;
      font-size: 14px;
      color: #888;
      text-align: center;
      margin: 4px auto;
      cursor: pointer;
      border-radius: 8px;
      .a {
        position: absolute;
        left: 50%;
        top: 12px;
        transform: translateX(-50%);
      }
      span {
        display: inline-block;
        margin-top: 31px;
      }
      .chengxu_em {
        width: 156px;
        height: 184px;
        background-color: #fff;
        position: absolute;
        top: 0;
        left: -175px;
        text-align: center;
        font-size: 16px;
        color: #333;
        border-radius: 8px;
        img {
          width: 114px;
          height: 114px;
          margin-top: 21px;
        }
      }
      .kf_tel {
        width: 190px;
        height: 244px;
        background-color: #fff;
        position: absolute;
        top: -84px;
        left: -210px;
        border-radius: 8px;
        box-shadow: 0 3px 22px 1px rgba(0, 0, 0, 0.06);
        padding: 12px 10px 16px;
        box-sizing: border-box;
        .toptel {
          border-bottom: 1px solid #eee;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 17px;
          padding: 0 10px;
          padding-bottom: 12px;
          box-sizing: border-box;
          .leftphoto img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
          }
          .rightphone {
            font-size: 14px;
            color: #333;
            text-align: left;
          }
        }
        .bottomma img {
          width: 114px;
          height: 114px;
          margin-bottom: 11px;
        }
        .bottomma div {
          font-size: 14px;
          color: #333;
        }
      }
    }
    .hover-actived > img {
      width: 26px;
      height: 26px;
    }
    .hover-actived > span {
      margin-top: 45px !important;
    }
  }
}
</style>
